// @flow
import type { Service, ServiceActionType } from '../types';
import { ServiceActionTypes } from '../constants';
import getActionMeta from './getActionMeta';

export default function actionMeta(
  service: Service,
  actionKey: string,
  typeOf: ServiceActionType = ServiceActionTypes.READ
) {
  if (!service || !service[typeOf]) {
    return null;
  }
  return getActionMeta(service[typeOf], actionKey);
}
